import React from 'react';
import { useTranslation } from 'react-i18next';
import TimeSlotButton from './TimeSlotButton';
import type { CrossServiceAlternative } from '@features/booking/hooks/useBookingFlow';
import type { ServiceType } from '@features/booking/state/types';

interface CrossServiceAlternativesProps {
  alternatives: CrossServiceAlternative[];
  onSelectSlot: (service: ServiceType, time: string) => void;
}

const CrossServiceAlternatives = ({ alternatives, onSelectSlot }: CrossServiceAlternativesProps) => {
  const { t } = useTranslation('booking');

  if (alternatives.length === 0) return null;

  return (
    <>
      {alternatives.map((alt) => (
        <div key={alt.service}>
          <div className="border-t border-border my-6" />
          <p className="text-foreground font-medium text-center mb-4">
            {t('RESERVATIONS_FOR')} {t(`FILTER_STRING_${alt.service.toUpperCase()}`)}
          </p>
          <div className="flex flex-col gap-4 mb-6" role="radiogroup" aria-label={`${alt.service} times`}>
            {alt.slots.map((slot) => (
              <div key={slot.time} className="flex flex-col items-center">
                <TimeSlotButton
                  time={slot.time}
                  selected={false}
                  onClick={() => onSelectSlot(alt.service, slot.time)}
                  isPremium={slot.isPremium}
                  type={slot.type}
                  hasEventMenu={slot.hasEventMenu}
                />
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  );
};

export default React.memo(CrossServiceAlternatives);
